import RoundInspectionModule from '../../../components/common/RoundInspection/RoundInspectionModule';
import React from "react";
import Dashboard from "../../../components/pages/residential/dashboard/Dashboard";
import RoleList from "../../../components/pages/residential/SiteManagement/Role/RoleList";
import RoleForm from "../../../components/pages/residential/SiteManagement/Role/RoleForm";
import SiteList from "../../../components/pages/residential/SiteManagement/Site/SiteList";
import SiteForm from "../../../components/pages/residential/SiteManagement/Site/SiteForm";
import WingList from "../../../components/pages/residential/SiteManagement/Wing/WingList";
import WingForm from "../../../components/pages/residential/SiteManagement/Wing/WingForm";
import FloorList from "../../../components/pages/residential/SiteManagement/Floor/FloorList";
import FloorForm from "../../../components/pages/residential/SiteManagement/Floor/FloorForm";
import UnitManagementMain from "../../../components/pages/residential/SiteManagement/Unit/UnitManagementMain";
import UnitForm from "../../../components/pages/residential/SiteManagement/Unit/UnitForm";
import UnitNumberForm from "../../../components/pages/residential/SiteManagement/Unit/UnitNumberForm";
import SiteHierarchyBuilder from "../../../components/pages/residential/SiteManagement/SiteHierarchyBuilder";
import SiteSetupWizard from "../../../components/pages/residential/SiteManagement/SiteSetupWizard";
import MenuList from "../../../components/pages/residential/SiteManagement/Menu/MenuList";
import MenuForm from "../../../components/pages/residential/SiteManagement/Menu/MenuForm";
import ManageUsers from "../../../components/pages/residential/UserManagement/ManageUsers";
import UserManagementForm from "../../../components/pages/residential/UserManagement/UserManagementForm";
import TenantTenancyStepper from "../../../components/pages/residential/UserManagement/TenancyStepper/TenantTenancyStepper";
import MyProfile from "../../../components/pages/Profile/MyProfile";
import VisitorRequest from "../../../components/pages/residential/VisitorsManagment/InviteVisitor/VisitorRequest";
import InviteGuestForm from "../../../components/pages/residential/VisitorsManagment/InviteVisitor/InviteGuestForm";
import GroupInviteForm from "../../../components/pages/residential/VisitorsManagment/InviteVisitor/GroupInviteForm";
import WalkInVisitorList from "../../../components/pages/residential/VisitorsManagment/walkinVisitor/WalkInVisitorList";
import GenerateQRCode from "../../../components/pages/residential/VisitorsManagment/QRCode/GenerateQRCode";
import VisitorReports from "../../../components/pages/residential/VisitorsManagment/Reports/VisitorReports";
import ParkingOperations from "../../../components/pages/residential/ParkingManagement/ParkingOperations";
import VehicleRegistry from "../../../components/pages/residential/ParkingManagement/vehicleregistry/VehicleRegistry";
import TenantFleetList from "../../../components/pages/residential/ParkingManagement/vehicleregistry/TenantFleetList";
import PayAndPark from "../../../components/pages/residential/ParkingManagement/payandpark/PayAndPark";
import AddVehicle from "../../../components/pages/residential/ParkingManagement/vehicleregistry/AddVehicle";
import RentalParkingList from "../../../components/pages/residential/ParkingManagement/rentalparking/RentalParkingList";
import OfferLease from "../../../components/pages/residential/ParkingManagement/rentalparking/OfferLease";
import LeaseDetails from "../../../components/pages/residential/ParkingManagement/rentalparking/LeaseDetails";
import AlertNotificationList from "../../../components/pages/residential/AlertNotification/AlertNotificationList";
import AlertNotificationForm from "../../../components/pages/residential/AlertNotification/AlertNotificationForm";
import MaintenanceModule from "../../../components/pages/residential/Maintenance/MaintenanceModule";
import MaintenanceForm from "../../../components/pages/residential/Maintenance/MaintenanceForm";
import VisitorPass from "../../../components/pages/residential/VisitorsManagment/visitorpass/VisitorPass";
import AttendanceList from "../../../components/pages/residential/UserManagement/Attendance/AttendanceList";
import AnnouncementList from "../../../components/pages/residential/Announcement/AnnouncementList";
import AnnouncementForm from "../../../components/pages/residential/Announcement/AnnouncementForm";
import ComplaintList from "../../../components/pages/residential/ComplaintManagement/ComplaintList";
import ComplaintForm from "../../../components/pages/residential/ComplaintManagement/ComplaintForm";
import AllocationTypeList from "../../../components/pages/residential/ParkingManagement/allocationtypes/AllocationTypeList";
import ParkingReports from "../../../components/pages/residential/ParkingManagement/reports/ParkingReports";
import ParkingTypeMasterList from "../../../components/pages/residential/ParkingManagement/master/ParkingTypeMaster/ParkingTypeMasterList";
import ParkingTypeMasterForm from "../../../components/pages/residential/ParkingManagement/master/ParkingTypeMaster/ParkingTypeMasterForm";
import VendorList from "../../../components/pages/residential/WorkforceManagement/Vendor/VendorList";
import VendorStaffList from "../../../components/pages/residential/WorkforceManagement/Vendor/VendorStaffList";
import VendorOnboardingForm from "../../../components/pages/residential/WorkforceManagement/Vendor/VendorOnboardingForm";
import VendorStaffForm from "../../../components/pages/residential/WorkforceManagement/Vendor/VendorStaffForm";
import VendorPass from "../../../components/pages/residential/WorkforceManagement/Vendor/VendorPass";
import StaffList from "../../../components/pages/residential/WorkforceManagement/Staff/StaffList";
import StaffRoleMaster from "../../../components/pages/residential/WorkforceManagement/Staff/StaffRoleMaster";
import StaffForm from "../../../components/pages/residential/WorkforceManagement/Staff/StaffForm";
import BulkDutyAllotment from "../../../components/pages/residential/WorkforceManagement/Staff/BulkDutyAllotment";
import StaffApprovalsDashboard from "../../../components/pages/residential/WorkforceManagement/Approvals/StaffApprovalsDashboard";
import ManagePreApprovals from "../../../components/pages/residential/WorkforceManagement/Approvals/ManagePreApprovals";
import NotificationUsersManage from "../../../components/pages/residential/VisitorsManagment/NotificationUsersManage";

export const residentialRoutes = [
  // Commercial Module Routes - NOTE: Paths are now relative to the mount point (e.g., /zentcomm/)
  {
    path: "dashboard",
    element: <Dashboard />,
    breadcrumbs: ["Dashboard"],
  },
  {
    path: "my-profile",
    element: <MyProfile />,
    breadcrumbs: ["My Profile"],
  },
  {
    path: "user-management",
    element: <ManageUsers />,
    breadcrumbs: ["User Management"],
  },
  {
    path: "user-management/form",
    element: <UserManagementForm />,
    breadcrumbs: ["User Management", "User Form"],
  },
  {
    path: "user-management/manage-tenancy",
    element: <TenantTenancyStepper />,
    breadcrumbs: ["User Management", "Manage Tenancy"],
  },
  {
    path: "attendance",
    element: <AttendanceList />,
    breadcrumbs: ["Attendance"],
  },
  {
    path: "attendance-managemnet",
    element: <AttendanceList />,
    breadcrumbs: ["Attendance"],
  },
  {
    path: "announcement",
    element: <AnnouncementList />,
    breadcrumbs: ["Announcements"],
  },
  {
    path: "announcement/add",
    element: <AnnouncementForm />,
    breadcrumbs: ["Announcements", "Add"],
  },
  {
    path: "announcement/edit/:id",
    element: <AnnouncementForm />,
    breadcrumbs: ["Announcements", "Edit"],
  },
  {
    path: "workforce-management/vendor",
    element: <VendorList />,
    breadcrumbs: ["Workforce Management", "Vendor", "List"],
  },
  {
    path: "workforce-management/vendor/onboard",
    element: <VendorOnboardingForm />,
    breadcrumbs: ["Workforce Management", "Vendor", "Onboard"],
  },
  {
    path: "workforce-management/vendor/pass",
    element: <VendorPass />,
    breadcrumbs: ["Workforce Management", "Vendor", "Generate pass"],
  },
  {
    path: "workforce-management/vendor/staff",
    element: <VendorStaffList />,
    breadcrumbs: ["Workforce Management", "Vendor", "Staff List"],
  },
  {
    path: "workforce-management/vendor/staff/add",
    element: <VendorStaffForm />,
    breadcrumbs: ["Workforce Management", "Vendor", "Add Staff"],
  },
  {
    path: "workforce-management/staff",
    element: <StaffList />,
    breadcrumbs: ["Workforce Management", "Staff", "List"],
  },
  {
    path: "workforce-management/staff/all",
    element: <StaffList listMode="all" />,
    breadcrumbs: ["Workforce Management", "All Staff"],
  },
  {
    path: "workforce-management/staff-roles",
    element: <StaffRoleMaster />,
    breadcrumbs: ["Workforce Management", "Staff Roles"],
  },
  {
    path: "workforce-management/staff/add",
    element: <StaffForm />,
    breadcrumbs: ["Workforce Management", "Staff", "Add"],
  },
  {
    path: "workforce-management/staff/allot-duty",
    element: <BulkDutyAllotment />,
    breadcrumbs: ["Workforce Management", "Staff", "Bulk Duty Allotment"],
  },
  {
    path: "workforce-management/approvals/dashboard",
    element: <StaffApprovalsDashboard />,
    breadcrumbs: ["Workforce Management", "Approvals", "Pending Requests"],
  },
  {
    path: "workforce-management/approvals/pre-approvals",
    element: <ManagePreApprovals />,
    breadcrumbs: ["Workforce Management", "Approvals", "Manage Pre-Approvals"],
  },
  {
    path: "visitor-managment/invited-visitor",
    element: <VisitorRequest />,
    breadcrumbs: ["Visitor Management", "Invited Visitor"],
  },
  {
    path: "visitor-managment/invited-visitor/add",
    element: <InviteGuestForm />,
    breadcrumbs: ["Visitor Management", "Invited Visitor", "Add"],
  },
  {
    path: "visitor-managment/invited-visitor/group-invite",
    element: <GroupInviteForm />,
    breadcrumbs: ["Visitor Management", "Invited Visitor", "Group Invite"],
  },
  {
    path: "visitor-managment/visitor-pass",
    element: <VisitorPass />,
    breadcrumbs: ["Visitor Management", "Visitor Pass"],
  },
  {
    path: "visitor-managment/walk-in-visitor",
    element: <WalkInVisitorList />,
    breadcrumbs: ["Visitor Management", "Walk-In Visitor"],
  },
  {
    path: "visitor-managment/generateQR",
    element: <GenerateQRCode />,
    breadcrumbs: ["Visitor Management", "Generate QR Code"],
  },
  {
    path: "report/visitor",
    element: <VisitorReports />,
    breadcrumbs: ["Reports", "Visitor Report"],
  },
  {
    path: "parking-management/operations",
    element: <ParkingOperations />,
    breadcrumbs: ["Parking Management", "Parking Operations"],
  },
  {
    path: "parking-management/vehicle-registry",
    element: <VehicleRegistry />,
    breadcrumbs: ["Parking Management", "Vehicle Registry"],
  },
  {
    path: "parking-management/tenant-fleet",
    element: <TenantFleetList />,
  },
  {
    path: "parking-management/pay-and-park",
    element: <PayAndPark />,
    breadcrumbs: ["Parking Operations", "Pay & Park"],
  },
  {
    path: "parking-management/allocation-types",
    element: <AllocationTypeList />,
    breadcrumbs: ["Parking Management", "Allocation Types"],
  },
  {
    path: "parking-management/reports",
    element: <ParkingReports />,
    breadcrumbs: ["Parking Management", "Reports"],
  },
  {
    path: "parking-management/rental-parking",
    element: <RentalParkingList />,
    breadcrumbs: ["Parking Management", "Rental Parking"],
  },
  {
    path: "parking-management/rental-parking/offer",
    element: <OfferLease />,
    breadcrumbs: ["Parking Management", "Rental Parking", "Offer Lease"],
  },
  {
    path: "parking-management/rental-parking/:id",
    element: <LeaseDetails />,
    breadcrumbs: ["Parking Management", "Rental Parking", "Lease Details"],
  },
  {
    path: "parking-management/vehicle-registry/:tenantId",
    element: <TenantFleetList />,
    breadcrumbs: ["Parking Management", "Vehicle Registry", "Fleet Vehicles"],
  },
  {
    path: "parking-management/vehicle-registry/:tenantId/add",
    element: <AddVehicle />,
    breadcrumbs: ["Parking Management", "Vehicle Registry", "Fleet Vehicles", "Add Vehicle"],
  },
  {
    path: "site-management/site",
    element: <SiteList />,
    breadcrumbs: ["Site Management", "Site List"],
  },
  {
    path: "site-management/site/form",
    element: <SiteForm />,
    breadcrumbs: ["Site Management", "Site", "Form"],
  },
  {
    path: "site-management/builder",
    element: <SiteHierarchyBuilder />,
    breadcrumbs: ["Site Management", "Site Preview"],
  },
  {
    path: "site-management/setup-wizard",
    element: <SiteSetupWizard />,
    breadcrumbs: ["Site Management", "Setup Wizard"],
  },
  {
    path: "site-management/role",
    element: <RoleList />,
    breadcrumbs: ["Site Management", "Role List"],
  },
  {
    path: "site-management/role/form",
    element: <RoleForm />,
    breadcrumbs: ["Site Management", "Role", "Form"],
  },
  {
    path: "site-management/wing",
    element: <WingList />,
    breadcrumbs: ["Site Management", "Wing"],
  },
  {
    path: "site-management/wing/form",
    element: <WingForm />,
    breadcrumbs: ["Site Management", "Wing", "Form"],
  },
  {
    path: "site-management/floor",
    element: <FloorList />,
    breadcrumbs: ["Site Management", "Floor"],
  },
  {
    path: "site-management/floor/form",
    element: <FloorForm />,
    breadcrumbs: ["Site Management", "Floor", "Form"],
  },
  {
    path: "site-management/unit",
    element: <UnitManagementMain />,
    breadcrumbs: ["Site Management", "Unit"],
  },
  {
    path: "site-management/unit/form",
    element: <UnitForm />,
    breadcrumbs: ["Site Management", "Unit", "Form"],
  },
  {
    path: "site-management/unit-number/form",
    element: <UnitNumberForm />,
    breadcrumbs: ["Site Management", "Unit", "Unit Number Form"],
  },
  {
    path: "site-management/menu",
    element: <MenuList />,
    breadcrumbs: ["Site Management", "Menu"],
  },
  {
    path: "site-management/menu/form",
    element: <MenuForm />,
    breadcrumbs: ["Site Management", "Menu", "Form"],
  },
  {
    path: "alert-notification",
    element: <AlertNotificationList />,
    breadcrumbs: ["Alert Notification", "List"],
  },
  {
    path: "alert-notification/add",
    element: <AlertNotificationForm />,
    breadcrumbs: ["Alert Notification", "Add Notification"],
  },
  {
    path: "alert-notification/edit/:id",
    element: <AlertNotificationForm />,
    breadcrumbs: ["Alert Notification", "Edit Notification"],
  },
  {
    path: "maintenance",
    element: <MaintenanceModule />,
    breadcrumbs: ["Maintenance"],
  },
  {
    path: "maintenance/add",
    element: <MaintenanceForm />,
    breadcrumbs: ["Maintenance", "Add Maintenance"],
  },
  {
    path: "complaint-management",
    element: <ComplaintList />,
    breadcrumbs: ["Complaints"],
  },
  {
    path: "complaint-management/add",
    element: <ComplaintForm />,
    breadcrumbs: ["Complaints", "Raise Complaint"],
  },
  {
    path: "complaint-management/edit/:id",
    element: <ComplaintForm />,
    breadcrumbs: ["Complaint Management", "Edit"],
  },
  {
    path: "parking-type-master",
    element: <ParkingTypeMasterList />,
    breadcrumbs: ["Parking Management", "Parking Type Master"],
  },
  {
    path: "parking-type-master/add",
    element: <ParkingTypeMasterForm />,
    breadcrumbs: ["Parking Management", "Parking Type Master", "Add"],
  },
  {
    path: "parking-type-master/edit/:id",
    element: <ParkingTypeMasterForm />,
    breadcrumbs: ["Parking Management", "Parking Type Master", "Edit"],
  },
  {
    path: "visitor/notification-users",
    element: <NotificationUsersManage />,
    breadcrumbs: ["Visitor Management", "Notification Receivers"],
  },
  {
    path: "visitor/notification-users/:unitId",
    element: <NotificationUsersManage />,
    breadcrumbs: ["Visitor Management", "Notification Receivers"],  },
  {
    path: "round-inspection",
    element: <RoundInspectionModule />,
    breadcrumbs: ["Staff Rounds & Inspection"],
  },
  {
    path: "round-inspection/*",
    element: <RoundInspectionModule />,
    breadcrumbs: ["Staff Rounds & Inspection"],
  },
];
